import styled, { css } from 'styled-components';
import { Typography } from '../../../global/theme';
import { mobile_xl, tablet_s } from '../../../global/mediaQueryMixin';
import { AlignCenter, FlexBetween, FlexCenter } from '../../../global/commonStyle';
interface Props {
  tone?: 'primary' | 'critical';
  justifyAlign?: 'center' | 'spaceBetween';
  align?: 'center' | 'flex-start';
  iconTone?: 'fill' | 'stroke';
  isActive?: boolean;
  isCalenderDropdown?: boolean;
  isSnoozeDropdown?: boolean;
  isSuffixIcon?: boolean;
}

const Label = styled.p<Props>`
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  ${Typography.body_md}
  margin: var(--space-0);
  ${(props) =>
    props.tone === 'critical' &&
    css`
      color: var(--accent-error);
    `}
  ${(props) =>
    props.tone === 'primary' &&
    css`
      color: var(--text-primary);
    `}
    ${mobile_xl(css`
    ${Typography.body_lg}
  `)}
`;

const ItemMainDiv = styled.div`
  padding-inline: var(--space-4);
  ${mobile_xl(css`
    padding-inline: var(--space-10);
  `)}
`;

const Item = styled.div<Props>`
  ${FlexBetween}
  padding: var(--space-4) var(--space-6);
  cursor: pointer;
  gap: var(--space-16);
  border-radius: var(--border-radius-4);
  svg {
    margin: var(--space-2) var(--space-1);
    ${({ iconTone, tone }) =>
      iconTone === 'fill' &&
      css`
        fill: ${tone === 'critical' ? 'var(--accent-error)' : 'var(--text-primary)'};
      `}
    ${({ iconTone, tone }) =>
      iconTone === 'stroke' &&
      css`
        stroke: ${tone === 'critical' ? 'var(--accent-error)' : 'var(--text-primary)'};
        fill: none;
      `}
  }
  ${({ isSuffixIcon }) =>
    isSuffixIcon &&
    css`
      padding-inline: var(--space-6) var(--space-4);
    `}
  .close-icon-tag {
    height: max-content;
    visibility: hidden;
    svg {
      margin: var(--space-0);
    }
    &:hover {
      background: var(--background-muted);
    }
  }
  &:hover {
    background-color: var(--neutral-secondary);
    .close-icon-tag {
      visibility: visible;
    }
  }
  ${(props) =>
    props.justifyAlign === 'center' &&
    css`
      justify-content: center;
    `}
  ${(props) =>
    props.justifyAlign === 'spaceBetween' &&
    css`
      justify-content: space-between;
    `}
    ${(props) =>
    props.isActive &&
    css`
      background-color: var(--neutral-secondary);
    `}
    ${mobile_xl(css<Props>`
    padding: var(--space-12);
    border-radius: var(--border-radius-8);
    ${(props) =>
      props.isCalenderDropdown &&
      css`
        padding: var(--space-6) var(--space-3);
      `}
  `)}
`;
const DropDiv = styled.div<Props>`
  display: flex;
  width: 100%;
  gap: var(--space-8);
  overflow: hidden;
  ${(props) =>
    props.align === 'center' &&
    css`
      align-items: center;
    `}
  ${(props) =>
    props.align === 'flex-start' &&
    css`
      align-items: flex-start;
    `}
`;

const Suffix = styled.p<Props>`
  ${Typography.body_md}
  color: var(--text-secondary);
  margin: var(--space-0);
  display: flex;
  ${({ isSnoozeDropdown }) =>
    isSnoozeDropdown &&
    css`
      white-space: nowrap;
    `}
`;

const DescriptionDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
  overflow: hidden;
`;

const Description = styled.div`
  ${Typography.body_sm}
  color: var(--text-secondary);
`;

const AvatarDiv = styled.div`
  ${FlexCenter}
`;

const CheckMarkIcon = styled.div`
  display: none;
  ${tablet_s(css`
    display: flex;
  `)}
`;

const Autotext = styled.div`
  ${AlignCenter}
`;

export { Label, Item, DropDiv, Suffix, DescriptionDiv, Description, ItemMainDiv, AvatarDiv, CheckMarkIcon, Autotext };
